import { authorizedInstance } from "../config/axios"
import { buildQueryString } from "../utils"

export const getRadPeerReports = async (filters) => {
  const response = await authorizedInstance.get(
    `/radpeer-reports/?${buildQueryString(filters)}`
  )
  return response.data
}
